import React from 'react';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';

export default function LoginPage({ onLogin }) {
  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center">
      <div className="text-center max-w-md">
        <ShieldCheckIcon className="h-16 w-16 text-blue-500 mx-auto mb-6" />
        <h1 className="text-2xl font-bold text-gray-100 mb-2">
          Blue365Signal Portal
        </h1>
        <p className="text-gray-500 mb-8">
          Security Investigation Portal. Sign in with your organization account to continue.
        </p>
        <button
          onClick={onLogin}
          className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-500 text-white font-medium rounded-lg transition-colors"
        >
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}
